export default "__VITE_ASSET__CTpc5vcZ__"